import { useQuery } from '@tanstack/react-query';

import { getClientReportsList } from 'api/client-reports/client-reports.api';

import type { ClientReportsListParams } from 'api/client-reports/client-reports.api';
import type { CollectionResponse } from 'api/market-view-api';
import type { UseQueryResult } from '@tanstack/react-query';

interface UseClientReportsListArgs {
  userId: string | undefined;
  clientId: string | number | undefined;
  queryParams: ClientReportsListParams;
  enabled?: boolean;
}

export const clientReportsKeys = {
  all: ['client-reports'] as const,
  lists: () => [...clientReportsKeys.all, 'list'] as const,
  list: (
    clientId: string | number | undefined,
    params: ClientReportsListParams
  ) => [...clientReportsKeys.lists(), clientId, params] as const,
};

export const useClientReportsList = ({
  userId,
  clientId,
  queryParams,
  enabled = true,
}: UseClientReportsListArgs): UseQueryResult<CollectionResponse, Error> =>
  useQuery({
    queryKey: clientReportsKeys.list(clientId, queryParams),
    queryFn: () =>
      getClientReportsList(userId ?? '', clientId ?? '', queryParams),
    enabled: enabled && !!userId && !!clientId,
    staleTime: 30000,
    placeholderData: (previousData) => previousData,
  });
